export default __webpack_public_path__ + "static/media/OGApe.3aa82578.webp";